export function redirectWithGet(url) {
  document.location.href = url;
}

export function redirectWithPost(url) {
  const tmp = document.createElement('div');
  const [query, hash = ''] = url.split('#');
  const { base, params } = parseUrl(query);
  tmp.innerHTML = `<form action="${base}${hash}" method="post">${params
    .map(
      ({ name, value }) => `
        <input type="hidden" name="${name}" value="${fixValue(name, value)}" />
      `
    )
    .join('')}</form>`;
  const eForm = tmp.firstElementChild;
  document.body.appendChild(eForm);
  eForm.submit();
}

// 07/2023: Los params.value del query tendrán un encodeURI que debemos tratar
// 05/2025 Problema con URLSearchParams: Si user envía un espacio en blanco lo convierte en '+' y no lo decodifica
//         https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams#preserving_plus_signs
function fixValue(name, value) {
  if (name === 'user') {
    value = value.replaceAll('+', '%20');
  }
  return decodeURIComponent(value);
}

function parseUrl(url) {
  if (url.indexOf('?') === -1) {
    return { base: url, params: [] };
  }

  const [base, querystring] = url.split('?');
  const params = querystring
    .split('&')
    .reduce((acc, cur) => {
      const [name = '', value = ''] = cur.split('=');
      return [{ name, value }, ...acc];
    }, [])
    .filter((obj) => obj.name !== '');
  return { base, params };
}
